import { Component } from '@angular/core';

@Component({
    selector: 'kui-header-nav-links',
    templateUrl: './header-nav-links.component.html',
    standalone: false
})
export class KuiHeaderNavLinksComponent { }
